<form [formGroup]="formName">
    <div class="relative">
        <p-inputNumber [formControlName]="field?.isOneToMultiple ? field?.attributeCodeOneToMultiple : field.attributeCode" [showButtons]="true" [min]="field?.validation?.min" [max]="field?.validation?.max"
        buttonLayout="horizontal"  spinnerMode="horizontal" [step]="1" [min]="0" [class]="(moduleName === configSettingEntityCode || moduleName === securitySettingsEntityCode)? 'number-field' : ''"
        decrementButtonClass="p-button" incrementButtonClass="p-button" incrementButtonIcon="pi pi-plus"
        decrementButtonIcon="pi pi-minus" class="w-full" [placeholder]="placeholder"></p-inputNumber>
    </div>
</form>
